const styles = theme => ({
    appBar: {
        position: 'relative'
    },
    flex: {
        flex: 1,
    },
    grow: {
        flexGrow: 1,
    }
});

export default styles;